<template>
  <div class="discover-component">
    <div class="filters" data-slideout-ignore>
      <div
        class="show-filters"
        v-if="isMobile"
        v-on:click="showFilters = !showFilters"
        :class="{ isOpen: showFilters }"
      >
        <!--ajoute la classe isOpen si showFilters = true-->
        {{ showFiltersText }}
      </div>
      <transition name="fade">
        <div v-show="showFilters" class="container">
          <div class="filter" v-if="!hideRegion">
            <select v-model="selected_region" v-on:change="filterChange()">
              <option value="">{{ selectRegionNeighborhoodText }}</option>
              <option :key="region" v-for="region in regions" :value="region">
                {{ region }}
              </option>
            </select>
          </div>

          <p v-if="projectTypeId == 10" class="filter-label">
            {{ moveInText }}
          </p>

          <div v-if="projectTypeId == 10" class="date">
            <div class="filter month" v-if="units.length > 0">
              <select v-model="months" v-on:change="filterChange()">
                <option value="">{{ monthsText }}</option>
                <option :key="n" v-for="n in months_range" :value="n">
                  {{
                    new Date("2020/" + n + "/01").toLocaleString(
                      locale + "-CA",
                      { month: "long" }
                    )
                  }}
                </option>
              </select>
            </div>

            <div class="filter" v-if="units.length > 0">
              <select v-model="years" v-on:change="filterChange()">
                <option value="">{{ yearsText }}</option>
                <option :key="n" v-for="n in years_range" :value="n">
                  {{ n }}
                </option>
              </select>
            </div>
          </div>

          <div
            class="filter"
            v-if="commercialProjectCategories.length > 0 && projectTypeId != 10"
          >
            <select
              v-model="selected_commercialSpaceType"
              v-on:change="filterChange()"
            >
              <option value="">{{ selectCommercialSpaceTypeText }}</option>
              <option
                :key="commercialProjectCategory"
                v-for="commercialProjectCategory in commercialProjectCategories"
                :value="commercialProjectCategory"
              >
                {{ commercialProjectCategory }}
              </option>
            </select>
          </div>

          <div class="filter" v-if="units.length > 0 && projectTypeId == 10">
            <select v-model="bedrooms" v-on:change="filterChange()">
              <option value="">{{ bedroomsText }}</option>
              <option :key="n" v-for="n in bedrooms_range" :value="n">
                {{ n }}
              </option>
            </select>
          </div>

          <div class="filter" v-if="units.length > 0 && projectTypeId == 10">
            <select v-model="bathrooms" v-on:change="filterChange()">
              <option value="">{{ bathroomsText }}</option>
              <option :key="n" v-for="n in bathrooms_range" :value="n">
                {{ n }}
              </option>
            </select>
          </div>

          <div class="filter filter--range" v-if="units.length > 0 && projectTypeId != 10">
            <span>{{ priceRangeText }}</span>
            <div class="slider-wrapper">
              <span class="range-left">{{ priceFormat(price_range[0]) }}</span>
              <vue-slider
                ref="priceSlider"
                :formatter="price_format"
                :min="min_price"
                :max="max_price"
                :real-time="true"
                :tooltip="false"
                :height="1"
                :dotSize="10"
                v-model="price_range"
                v-on:callback="filterChange(true)"
              ></vue-slider>
              <span class="range-right">{{ priceFormat(price_range[1]) }}</span>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="map">
      <div id="map" style="width: 100%; height: 100%"></div>
    </div>

    <div class="results">
      <h1>
        <span v-if="nbProjects < 1">{{ nbProjects }} {{ projectText }}</span>
      </h1>
      <div ref="project-list-wrapper">
        <transition-group
          name="list"
          tag="div"
          :class="'project-list ' + 'id-' + projectTypePath"
          v-on:before-leave="beforeLeave"
          v-on:after-leave="afterLeave"
          ref="projectlist"
        >
          <project
            v-for="(project, index) in filteredProjects"
            :key="project.id"
            :project="project"
            :index="index"
            :parameters="getParameters()"
            :contact-link-root="contactLinkRoot"
            :project-type-path="projectTypePath"
            :project-type-title="projectTypeTitle"
            :rented-text="rentedText"
            :from-text="fromText"
            :taxe-text="taxeText"
            :see-brochure-text="seeBrochureText"
            :see-units-text="seeUnitsText"
            :register-now-text="registerNowText"
            :waiting-list-text="waitingListText"
            :details-text="detailsText"
          ></project>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import vueSlider from "vue-slider-component";
import project from "./Project";
import _ from "lodash";
import TWEEN from "@tweenjs/tween.js";
import helpers from "../helpers";
import constants from "../constants";
import * as PhotoSwipe from "photoswipe";
import * as PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

export default {
  components: {
    vueSlider,
    project,
  },

  props: [
    "allProjects",
    "areaText",
    "bathroomsText",
    "bedroomsText",
    "commercialProjectType",
    "contactLinkRoot",
    "detailsText",
    "fromText",
    "locale",
    "monthsText",
    "moveInText",
    "priceRangeText",
    "projectsText",
    "projectText",
    "projectTypeId",
    "projectTypePath",
    "projectTypeTitle",
    "region",
    "registerNowText",
    "rentedText",
    "seeBrochureText",
    "seeUnitsText",
    "selectCommercialSpaceTypeText",
    "selectRegionNeighborhoodText",
    "showFiltersText",
    "spaceCategoryText",
    "taxeText",
    "unitsText",
    "unitText",
    "waitingListText",
    "yearsText",
  ],

  data() {
    return {
      imagePdf: require("../../images/pdf.png"),
      imageCamera: require("../../images/camera.png"),
      imagePdfOn: require("../../images/pdf-white.png"),
      imageCameraOn: require("../../images/camera-white.png"),
      gm: null,
      markerClusterer: null,

      projects: [],
      units: [],
      regions: [],
      commercialProjectCategories: [],

      selected_region: "",
      selected_commercialSpaceType: "",

      min_price: 0,
      max_price: 0,
      price_range: [0, 0],
      price_format: (value) => {
        return helpers.formatPrice(value);
      },

      markers: {},

      bedrooms: "",
      bedrooms_range: [1, 2],

      bathrooms: "",
      bathrooms_range: [1, 2],

      months: "",
      years: "",
      months_range: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      years_range: [],

      scrollTimeout: null,

      nbProjects: 0,
      nbUnits: 0,

      showFilters: true,

      isMobile: false,

      hideRegion: false,

      hoverIconePdf: false,

      hoverIconeCamera: false,

      hideCommercialSpaceType: false,
    };
  },

  computed: {
    filteredProjects() {
      let filteredProjects = this.projects;

      _.each(filteredProjects, (item) => {
        item.filteredUnits = this.filterUnits(item.units);
        item.isActive = !!item.isActive; // to refresh projects
      });

      if (this.selected_region !== "") {
        filteredProjects = _.filter(filteredProjects, (item) => {
          return item.region === this.selected_region;
        });
      }

      if (this.selected_commercialSpaceType !== "") {
        filteredProjects = _.filter(filteredProjects, (item) => {
          return (
            item.commercialProjectCategory === this.selected_commercialSpaceType
          );
        });
      }

      filteredProjects = _.filter(filteredProjects, (item) => {
        return (
          (item.filteredUnits.length > 0 || item.alwaysShow == 1) &&
          item.addToArchive == 0
        );
      });

      filteredProjects = _.sortBy(filteredProjects, (item) => {
        return item.rented === "1";
      });

      return filteredProjects;
    },
    filteredUnits() {
      return this.filterUnits(this.setUnitsFromProjects(this.filteredProjects));
    },
  },

  watch: {
    filteredProjects: function (newValue, oldValue) {
      this.updateMarkersOnMap();
      if (newValue.length !== oldValue.length) {
        this.fitBounds();
      }

      this.animateNumber(oldValue.length, newValue.length, (value) => {
        this.nbProjects = value;
      });
    },
    filteredUnits: function (newValue, oldValue) {
      this.animateNumber(oldValue.length, newValue.length, (value) => {
        this.nbUnits = value;
      });
    },
  },

  created() {
    this.initMobile();
    this.initialiseData();
    this.appendGmScripts();
  },

  mounted() {
    this.refresh();
  },

  methods: {
    appendGmScripts() {
      var apiKey = constants.googleMapsApiKey();
      var callback = "gmCallback";

      var gmCallBack = document.createElement("script");
      gmCallBack.appendChild(
        document.createTextNode(
          "function " + callback + "() { app.$refs.discover.gmCallback(); }"
        )
      );

      var markerClustererScript = document.createElement("script");
      markerClustererScript.setAttribute("src", "/scripts/markerclusterer.js");
      markerClustererScript.async = false;

      var gmScript = document.createElement("script");
      gmScript.setAttribute(
        "src",
        "https://maps.googleapis.com/maps/api/js?key=" +
          apiKey +
          "&callback=" +
          callback
      );
      gmScript.async = true;
      gmScript.defer = true;

      document.body.appendChild(gmCallBack);

      markerClustererScript.addEventListener("load", () => {
        document.body.appendChild(gmScript);
      });

      document.body.appendChild(markerClustererScript);
    },

    gmCallback() {
      this.gm = new google.maps.Map(
        document.getElementById("map"),
        constants.googleMapsOptions()
      );

      this.setInitialMarkers();
    },

    initialiseData() {
      _.each(this.allProjects, (value) => {
        value.isActive = false;
        value.fromPrice =
          value.units && value.units.length > 0
            ? helpers.formatPrice(this.getUnitMinValue(value.units, "price"))
            : "";
      });

      if (this.region) {
        this.allProjects = _.filter(this.allProjects, (item) => {
          return item.region === this.region;
        });
        this.selected_region = this.region;
        this.hideRegion = true;
      }
      var getRegion = helpers.getURLParameter("region");
      if (getRegion) {
        this.selected_region = getRegion;
      }

      if (this.commercialProjectCategory) {
        this.allProjects = _.filter(this.allProjects, (item) => {
          return (
            item.commercialProjectCategory === this.commercialProjectCategory
          );
        });
        this.selected_commercialSpaceType = this.commercialProjectCategory;
        this.hideCommercialSpaceType = true;
      }
      var getCommercial = helpers.getURLParameter("commercialSpaceType");
      if (getCommercial) {
        this.selected_commercialSpaceType = getCommercial.split("_").join(" ");
      }

      var getBedrooms = helpers.getURLParameter("bedrooms");
      if (getBedrooms) {
        this.bedrooms = getBedrooms;
      }

      var getBathrooms = helpers.getURLParameter("bathrooms");
      if (getBathrooms) {
        this.bathrooms = getBathrooms;
      }

      var getMonth = helpers.getURLParameter("move_in_month");
      if (getMonth) {
        this.months = getMonth;
      }

      var getYear = helpers.getURLParameter("move_in_year");
      if (getYear) {
        this.years = getYear;
      }

      this.projects = this.allProjects;

      this.units = this.setUnitsFromProjects(this.projects);
      if (this.units.length > 0) {
        this.setPriceRange();
        this.setBedroomsRange();
        this.setBathroomsRange();
        this.setYearsRange();
      }

      var getPrice = helpers.getURLParameter("priceRange");
      if (getPrice) {
        this.price_range = getPrice.split("~");
      }

      this.regions = _.sortBy(
        _.map(_.uniqBy(this.projects, "region"), (item) => {
          return item.region;
        })
      );

      this.commercialProjectCategories = _.filter(
        _.map(_.uniqBy(this.projects, "commercialProjectCategory"), (item) => {
          return item.commercialProjectCategory;
        }),
        (item) => {
          return item != "";
        }
      );
    },

    getParameters() {
      var parameters = {
        min_price: this.price_range[0],
        max_price: this.price_range[1],
        bedrooms: this.bedrooms,
        bathrooms: this.bathrooms,
        move_in_month: this.months,
        move_in_year: this.years,
        available: true,
      };
      return _.map(parameters, (v, k) => {
        return encodeURIComponent(k) + "=" + encodeURIComponent(v);
      }).join("&");
    },

    filterUnits(units) {
      if (units < 1) return [];
      return _.filter(units, (unit) => {
        const price = parseInt(unit.price);
        const filterResult = !(
          price < parseInt(this.price_range[0]) ||
          price > parseInt(this.price_range[1]) ||
          (this.bedrooms !== "" && unit.bedrooms != this.bedrooms) ||
          (this.bathrooms !== "" && unit.bathrooms != this.bathrooms)
        );

        // 10 is equal to "Appartments for rent"
        if (this.projectTypePath === "10") {
          const nextMonthDate = new Date();
          const unitAvailabilityDate = new Date(unit.dateAvailableFormatted);

          nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

          if (this.months !== "" || this.years !== "") {
            let month = this.months;
            let year = this.years;
            let moveInDate;

            if (this.months === "") month = new Date().getMonth();
            if (this.years === "") year = new Date().getFullYear();

            moveInDate = new Date(year + "/" + month + "/01");

            return (
              filterResult &&
              unitAvailabilityDate.getTime() <= moveInDate.getTime()
            );
          } else {
            return (
              filterResult &&
              unitAvailabilityDate.getTime() >= nextMonthDate.getTime()
            );
          }
        } else {
          return filterResult;
        }
      });
    },
    setUnitsFromProjects(projects) {
      return _.flatten(
        _.map(projects, (project) => {
          return project.units;
        })
      );
    },

    setPriceRange() {
      var minPrice = this.getUnitMinValue(this.units, "price");
      var maxPrice = this.getUnitMaxValue(this.units, "price");
      var roundNb = helpers.getPowerOfTen(minPrice) / 10;
      this.min_price = Math.floor(minPrice * (1 / roundNb)) * roundNb;
      this.max_price = Math.ceil(maxPrice * (1 / roundNb)) * roundNb;
      this.price_range = [this.min_price, this.max_price];
    },

    setBedroomsRange() {
      this.bedrooms_range = _.sortBy(
        _.uniq(
          _.flatMap(this.units, (unit) => {
            return unit.bedrooms.trim();
          })
        )
      );
      var pulledArray = _.remove(this.bedrooms_range, function (n) {
        return /^[a-z]+$/i.test(n);
      });

      this.bedrooms_range = this.bedrooms_range.filter(function (n) {
        return n !== "";
      });

      this.bedrooms_range.splice(0, 0, pulledArray);
      this.bedrooms_range = _.flatten(this.bedrooms_range);
    },

    setBathroomsRange() {
      this.bathrooms_range = _.sortBy(
        _.uniq(
          _.flatMap(this.units, (unit) => {
            return unit.bathrooms.trim();
          })
        )
      );
      var pulledArray = _.remove(this.bathrooms_range, function (n) {
        return /^[a-z]+$/i.test(n);
      });
      this.bathrooms_range.splice(0, 0, pulledArray);
      this.bathrooms_range = _.flatten(this.bathrooms_range);
    },

    setYearsRange() {
      for (let i = 0; i <= 5; i++) {
        let date = new Date().getFullYear() + i;
        this.years_range.push(date);
      }
    },

    getUnitMinValue(units, prop) {
      return parseInt(
        _.minBy(units, (unit) => {
          return parseInt(unit[prop]);
        })[prop]
      );
    },

    getUnitMaxValue(units, prop) {
      return parseInt(
        _.maxBy(units, (unit) => {
          return parseInt(unit[prop]);
        })[prop]
      );
    },

    getMarkerPosition(project) {
      let latitude = parseFloat(project.latitude);
      let longitude = parseFloat(project.longitude);
      return { lat: latitude, lng: longitude };
    },

    getMarkerIcon(project) {
      var icon =
        project.filteredUnits.length > 0
          ? "/images/curseur.png"
          : "/images/curseur.png";
      if (project.isActive) {
        icon =
          project.filteredUnits.length > 0
            ? "/images/curseur_over.png"
            : "/images/curseur_over.png";
      }
      return icon;
    },

    setInitialMarkers() {
      _.each(this.projects, (value, index) => {
        var marker = new google.maps.Marker({
          position: this.getMarkerPosition(value),
          icon: this.getMarkerIcon(value),
          project: value,
          hasMarkerClusterer: false,
        });
        this.markers[value.id] = marker;
        marker.addListener("click", () => {
          this.highlightProject(value, index);
        });
      });

      this.markerClusterer = new MarkerClusterer(this.gm, []);

      this.markerClusterer.setStyles([
        {
          textColor: "#000000",
          textSize: 11,
          url: "/images/curseur.png",
          width: 42,
          height: 60,
        },
        {
          textColor: "#000000",
          textSize: 11,
          url: "/images/curseur.png",
          width: 42,
          height: 60,
        },
        {
          textColor: "#000000",
          textSize: 11,
          url: "/images/curseur.png",
          width: 42,
          height: 60,
        },
        {
          textColor: "#000000",
          textSize: 11,
          url: "/images/curseur.png",
          width: 42,
          height: 60,
        },
        {
          textColor: "#000000",
          textSize: 11,
          url: "/images/curseur.png",
          width: 42,
          height: 60,
        },
      ]);

      this.fitBounds();
      this.updateMarkersOnMap();
    },

    updateMarkersOnMap() {
      if (!this.gm) return;

      _.each(this.markers, (value, key) => {
        if (
          !_.some(this.filteredProjects, (value2) => {
            return value2.id === key;
          })
        ) {
          if (value.hasMarkerClusterer) {
            value.hasMarkerClusterer = false;
            this.markerClusterer.removeMarker(value);
          }
        }
      });

      _.each(this.filteredProjects, (value, index) => {
        var marker = this.markers[value.id];

        if (!marker.hasMarkerClusterer) {
          marker.hasMarkerClusterer = true;
          this.markerClusterer.addMarker(marker);
        }
        marker.setIcon(this.getMarkerIcon(value));
      });

      _.each(this.markerClusterer.getClusters(), (cluster, index) => {
        if (cluster.clusterIcon_.div_ && cluster.clusterIcon_.div_.firstChild) {
          if (
            _.some(cluster.getMarkers(), (marker, index) => {
              return marker.project.isActive;
            })
          ) {
            cluster.clusterIcon_.div_.firstChild.src =
              "/images/curseur_over.png";
          } else {
            cluster.clusterIcon_.div_.firstChild.src = "/images/curseur.png";
          }
        }
      });
    },

    fitBounds() {
      if (!this.gm) return;

      let bounds = new google.maps.LatLngBounds();

      _.each(this.filteredProjects, (value) => {
        bounds.extend(this.getMarkerPosition(value));
      });

      let extend = 0.006;
      let extendPoint1 = new google.maps.LatLng(
        bounds.getNorthEast().lat() + extend,
        bounds.getNorthEast().lng() + extend
      );
      let extendPoint2 = new google.maps.LatLng(
        bounds.getSouthWest().lat() - extend,
        bounds.getSouthWest().lng() - extend
      );
      bounds.extend(extendPoint1);
      bounds.extend(extendPoint2);

      this.gm.fitBounds(bounds);

      google.maps.event.addListenerOnce(this.gm, "idle", () => {
        this.gm.panBy(0, 0);
      });
    },

    highlightProject(project) {
      _.each(this.projects, (value, index) => {
        value.isActive = value.id === project.id;
      });
      var activeIndex = 0;
      _.each(this.filteredProjects, (value, index) => {
        if (value.isActive) {
          activeIndex = index;
        }
      });

      var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName("body")[0],
        windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

      var currentProjectElement = document.querySelector(
        ".project[data-index='" + activeIndex + "']"
      );
      var discoverTop = document
        .querySelector(".discover-component")
        .getBoundingClientRect().top;
      var discoverHeight = document.querySelector(".discover-component")
        .clientHeight;
      var pageOffset = window.pageYOffset;
      var filterHeight = document.querySelector(".discover-component .filters")
        .clientHeight;
      var topToScroll =
        pageOffset +
        currentProjectElement.getBoundingClientRect().top -
        filterHeight -
        40;
      var discoverBottom =
        pageOffset + discoverTop + discoverHeight - windowHeight;

      if (topToScroll > discoverBottom) {
        topToScroll = discoverBottom;
      }
      helpers.scrollToTop(topToScroll, 600, 0);
    },

    filterChange(timeout = false) {
      _.each(this.projects, (value, index) => {
        value.isActive = false;
      });
      if (timeout) {
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = null;
        }
        this.scrollTimeout = setTimeout(() => {
          this.scrollToFilters();
        }, 1000);
      } else {
        this.scrollToFilters();
      }

      var stateObj = {
        region: this.selected_region,
        commercial: this.selected_commercialSpaceType,
        price: this.price_range,
        bedrooms: this.bedrooms,
        bathrooms: this.bathrooms,
        months: this.months,
        years: this.years,
      };
      var uri = helpers.updateQueryStringParameter(
        window.location.href,
        "region",
        this.selected_region
      );
      if (this.selected_commercialSpaceType !== "") {
        uri = helpers.updateQueryStringParameter(
          uri,
          "commercialSpaceType",
          this.selected_commercialSpaceType.split(" ").join("_")
        );
      }
      if (this.price_range.join("~") !== "0~0") {
        uri = helpers.updateQueryStringParameter(
          uri,
          "priceRange",
          this.price_range.join("~")
        );
      }
      if (this.bedrooms !== "") {
        uri = helpers.updateQueryStringParameter(
          uri,
          "bedrooms",
          this.bedrooms
        );
      }
      if (this.bathrooms !== "") {
        uri = helpers.updateQueryStringParameter(
          uri,
          "bathrooms",
          this.bathrooms
        );
      }
      if (this.months !== "") {
        uri = helpers.updateQueryStringParameter(
          uri,
          "move_in_month",
          this.months
        );
      }
      if (this.years !== "") {
        uri = helpers.updateQueryStringParameter(
          uri,
          "move_in_year",
          this.years
        );
      }
      history.pushState(stateObj, document.title, uri);
    },

    beforeLeave() {
      this.$refs["project-list-wrapper"].style.height =
        this.$refs["project-list-wrapper"].clientHeight + "px";
    },

    afterLeave() {
      this.$refs["project-list-wrapper"].style.height = "auto";
    },

    scrollToFilters() {
      var discoverTop = document
        .querySelector(".discover-component")
        .getBoundingClientRect().top;
      var mainNav = document.querySelector(".main-nav");
      var top = window.pageYOffset + discoverTop - mainNav.scrollHeight;
      helpers.scrollToTop(top, 600, 0);
    },

    priceFormat(value) {
      return helpers.formatPrice(value);
    },

    animateNumber(oldValue, newValue, callbak) {
      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }
      new TWEEN.Tween({ tweeningNumber: oldValue })
        .easing(TWEEN.Easing.Quadratic.Out)
        .to({ tweeningNumber: newValue }, 600)
        .onUpdate((object) => {
          callbak(object.tweeningNumber.toFixed(0));
        })
        .start();
      animate();
    },

    refresh() {
      if (this.$refs["priceSlider"]) {
        this.$refs["priceSlider"].refresh();
      }
    },

    initMobile() {
      if (window.matchMedia("(max-width: 900px)").matches) {
        this.isMobile = true;
        this.showFilters = false;
      }
    },

    openGallery(project) {
      var pswpElement = document.querySelector(".pswp");

      var options = {
        index: 0,
      };

      var gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        project.gallery,
        options
      );
      gallery.init();
    },
  },
};
</script>
